/* ------------------------- Réunions périodiques ------------------------- */
/**
 * PÉRIODICITÉ D'UN GT. « Généralement les réunions se font tout le temps au
 * même moment » — d'où trois cadences, et rien de plus : ce sont celles qu'un
 * groupe de travail pratique. Une expression de récurrence complète (RFC 5545)
 * serait un formulaire à part entière pour des cas que personne n'a demandés.
 */
export const MEETING_FREQUENCIES = ['hebdomadaire', 'bimensuelle', 'mensuelle'];
export const MEETING_FREQUENCY_LABELS = {
    hebdomadaire: 'Toutes les semaines',
    bimensuelle: 'Toutes les 2 semaines',
    mensuelle: 'Tous les mois',
};
/** Jours de la semaine, en numérotation ISO (1 = lundi … 7 = dimanche). */
export const WEEKDAYS = [
    { value: 1, label: 'Lundi' },
    { value: 2, label: 'Mardi' },
    { value: 3, label: 'Mercredi' },
    { value: 4, label: 'Jeudi' },
    { value: 5, label: 'Vendredi' },
    { value: 6, label: 'Samedi' },
    { value: 7, label: 'Dimanche' },
];
export const WEEKDAY_LABELS = Object.fromEntries(WEEKDAYS.map((j) => [j.value, j.label]));
/** Une série résumée en une phrase : « Toutes les 2 semaines, le mardi à 09:00 ». */
export function libelleSerie(s) {
    const jour = (WEEKDAY_LABELS[s.jourSemaine] ?? '').toLowerCase();
    const duree = s.dureeMinutes % 60 === 0
        ? `${s.dureeMinutes / 60} h`
        : `${Math.floor(s.dureeMinutes / 60)} h ${s.dureeMinutes % 60}`;
    return `${MEETING_FREQUENCY_LABELS[s.frequence]}, le ${jour} à ${s.heure} (${duree})`;
}
/** Taille maximale d'un PDF de compte rendu. */
export const ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
//# sourceMappingURL=reunions.js.map